<template>
    <div class="fill-product-info-root container">
      <div class="product-info">
        <div class="pic-frame">
          <img
            :src="goodsBaseInfo ? goodsBaseInfo.image : ''"
            class="pic"
            v-if="goodsBaseInfo && goodsBaseInfo.image"
          />
        </div>
        <div class="txt-content">
          <div class="big-title desp">
            <span> 商品名称</span>
            {{ goodsBaseInfo ? goodsBaseInfo.goodsName : "" }}
          </div>
          <div class="desp">
            <span>规格</span>
            {{ goodsBaseInfo ? goodsBaseInfo.specification : "" }}
          </div>
          <div class="desp">
            <span>生产厂家</span> {{ goodsBaseInfo ? goodsBaseInfo.factory : "" }}
          </div>
          <div class="desp">
            <span>批准文号</span>
            {{ goodsBaseInfo ? goodsBaseInfo.approvalNumber : "" }}
          </div>
        </div>
      </div>
      <div class="big-content">
        <formItem
          ref="formItem"
          :formIn="formIn"
          :AddIcon="AddIcon"
          :unitList="unitList"
          :shopLabelList="shopLabelList"
        />
  
        <div class="harf-block">
          <section class="big-block">
            <div class="title-block">
              <span class="text">销售规则</span>
            </div>
  
            <section class="form-content">
              <div class="row mutlti big">
                <div class="tip"><span class="weight">*</span> 客户类型</div>
                <div class="value fill">
                  <div class="flag-block">
                    <el-checkbox
                      style="margin-right: 30px"
                      v-model="checkAll"
                      :indeterminate="isIndeterminate"
                      :disabled="true"
                      >全选</el-checkbox
                    >
                    <el-checkbox-group
                      v-model="formIn.shopTypeCode"
                      :disabled="true"
                    >
                      <el-checkbox
                        v-if="listData && listData.length > 0"
                        :label="item.typeCode"
                        :key="item.typeCode"
                        v-for="item in listData ? listData : []"
                        >{{ item.typeName }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
  
              <div class="row contine">
                <div class="tip"></div>
                <div class="value fill small-tip">
                  <span> 注意：被勾选的客户类型对应的客户可购买当前商品。 </span>
                </div>
              </div>
              <div class="row mutlti big">
                <div class="tip">黑名单</div>
                <div class="value fill">
                  <div class="flag-block">
                    <el-radio
                      v-model="formIn.groupId"
                      :label="item.id"
                      :key="item.id"
                      v-for="item in userList ? userList : []"
                      :disabled="true"
                    >
                      {{ item.schemeName }}
                    </el-radio>
                  </div>
                </div>
              </div>
  
              <div class="row contine">
                <div class="tip"></div>
                <div class="value fill small-tip">
                  <span> 注意：黑名单客户不可购买当前商品。 </span>
                </div>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import formItem from "./salesGoodsItem.vue";
  const IConst_Add_Icon = require("@/assets/zz/add-icon.png");
  
  import {
    getunitList,
    getEnableListByType,
  } from "@/api/productManage/auditProduct";
  import { salesgroupinfoBySys } from "@/api/salesControl/commodity";
  import { getLabelInfoList } from "@/api/goods";
  import {
    queryAgencyControlPinSku,
  } from "@/api/product";
  import _ from "lodash";
  
  export default {
    components: { formItem },
    data() {
      return {
        AddIcon: IConst_Add_Icon,
        action: process.env.VUE_APP_BASE_API + "/product/goodsbase/upload",
        imgType: "",
        limit: 1,
        shopLabelList: [], //可选商品标签
        unitList: [], //可选单位
        listData: [], // 客户类型类别
        userList: [], //用户组列表
        isIndeterminate: false, //全选，不确定效果,选择了部分
        checkAll: true, //全选客户类型
  
        formIn: {
          beSynDate: false, //同步有效期和生产日期
          medicineCode: "", //ERP编码
          salePrice: "", //价格
          goodsSkuInventory: "", //总库存
          beSynStock: false, //自动同步库存
          goodsSkuUnit: "", //单位
          startWholesale: "", //起批量
          expireTime: "", //有效期至
          producedTime: "", //生产日期
          goodsSkuTitle: "", //商品标题
          batchNumber: "", //产品批号
          shopLabelId: "", //商品标签  数据来源待确认
          type: 1, //配置方式 0 设置区域、客户类型及黑名单  1 白名单
          shopTypeCode: [], //客户类型：1.诊所,2.春播运营平台,3.医药公司
          groupId: "", //用户组
          useTimes: false, //配数购买
        },
        goodsBaseInfo: {}, //商品基础详情
        goodsDetail: {}, //商品详情
        pageType: "", //页面类型 add 新增 edit 编辑
      };
    },
    computed: {},
    created() {
     
    },
    beforeDestroy() {},
    methods: {
      publicRequest() {
        this.initViews();
        this.queryGoodsDetail();
        this.getunitList();
        this.salesgroupinfo();
        this.getEnableListByType();
        this.pageType = this.$route.query.pageType;
      },
      // 初始化页面数据
      initViews() {
        let sessionItemGoods = window.sessionStorage.getItem("agentProductItem");
        this.goodsBaseInfo = JSON.parse(sessionItemGoods);
      },
  
      // 查询商品详情
      queryGoodsDetail() {
        console.log("this.goodsBaseInfo", this.goodsBaseInfo);
        const { goodsName, brand ,specification} = this.goodsBaseInfo;
        this.formIn.goodsSkuTitle = `${brand || ''} ${goodsName || ''} ${specification || ''}`;
        if (!this.goodsBaseInfo.goodsSkuId) {
          return;
        }
        queryAgencyControlPinSku(this.goodsBaseInfo.goodsSkuId).then((res) => {
          if (res) {
            this.goodsDetail = res;
            this.formIn = Object.assign(this.formIn, this.goodsDetail);
            this.formIn.goodsSkuTitle = `${brand || ''} ${goodsName || ''} ${specification || ''}`;
            if (res.shopTypeCode) {
              this.formIn.shopTypeCode = res.shopTypeCode.split(",");
            } else {
              this.formIn.shopTypeCode = [];
            }
          }
        });
      },
     
  
      // 获取单位字典
      getunitList() {
        getunitList().then((res) => {
          if (res.code == 0) {
            this.unitList = res.data || [];
          }
        });
      },
  
      // 查询用户组信息
      salesgroupinfo() {
        const { goodsSkuId } = this.goodsBaseInfo;
        if (!goodsSkuId) return;
        let params = {
          goodsSkuId
        };
        params.type = 1;
        salesgroupinfoBySys(params).then((res) => {
          this.userList = res;
        });
      },
  
      // 获取类型
      getEnableListByType() {
        let params = {
          type: 0,
        };
        getEnableListByType(params).then((res) => {
          if (res.code == 0) {
            this.listData = res.data; // 客户类型类别
          }
        });
      },
  
      handleBack(index) {
        this.$router.go(-1);
      },
   
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "../style/index.scss";
  .desp span {
    width: 80px;
    display: inline-block;
  }
  .big-title {
  }
  .weight {
    color: #f5222d;
  }
  </style>
  